export default "__VITE_ASSET__MeNi1s20__"